import { Injectable } from '@angular/core';
import { BusinessEntityService } from './business-entity.service';

@Injectable({
  providedIn: 'root'
})
export class AssumedRoleStoreService {
  loginUserRole: string;
  isAdmin: boolean;
  isBuyer: boolean;
  isManager: boolean;
  themeOwner: boolean;

  constructor(private readonly bservice: BusinessEntityService) { }

  assumeRoleByLocalStorage(localStorageAssumeUser) {
    if(localStorageAssumeUser.role==='PurappsUTAdmin'){
      this.loginUserRole='Admin';this.isAdmin=true
    }else if(localStorageAssumeUser.role==='PurappsBuyer'){
      this.loginUserRole='Buyer';this.isBuyer=true
    }else if(localStorageAssumeUser.role==='PurappsManager'){
      this.loginUserRole='Manager';this.isManager=true
      if(localStorageAssumeUser.is_theme_owner){
        this.themeOwner=true
      }
    }else if(localStorageAssumeUser.role==="PurappsSuperAdmin"){
      this.loginUserRole='PurappsSuperAdmin';this.isAdmin=true
    }
  }

  assumeRoleByBService() {
    if(this.bservice.loggedUserRole==='PurappsUTAdmin'){
      this.loginUserRole='Admin';this.isAdmin=true
    }else if(this.bservice.loggedUserRole==='PurappsBuyer'){
      this.loginUserRole='Buyer';this.isBuyer=true
    }else if(this.bservice.loggedUserRole==='PurappsManager'){
      this.loginUserRole='Manager';this.isManager=true
      if(this.bservice?.themeOwner){
        this.themeOwner=true
      }
    }else if(this.bservice.loggedUserRole==="PurappsSuperAdmin"){
      this.loginUserRole='PurappsSuperAdmin';this.isAdmin=true
    }
  }
}
